import { Table, Typography } from "antd";
import { useMemo, useState } from "react";

const { Title } = Typography;

export default function LectureHistory({ lectures, loading }) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredHistories = useMemo(() => {
    if (!lectures) return [];
    const lower = searchTerm.toLowerCase();
    return lectures.filter((h) =>
      [h.lecture_title, h.assistant_name, h.method, h.code_used]
        .filter(Boolean)
        .some((field) => field.toLowerCase().includes(lower))
    );
  }, [lectures, searchTerm]);

  function formatDate(dateString) {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("ar-EG", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    }).format(date);
  }

  const columns = [
    {
      title: "الاسم",
      dataIndex: "lecture_title",
      key: "title",
    },
    {
      title: "السعر",
      dataIndex: "price",
      key: "price",
      render: (price) => `${price} EGP`,
    },
    {
      title: "تاريخ الشراء",
      dataIndex: "buy_at",
      key: "buyDate",
      render: formatDate,
    },
    {
      title: "تاريخ الانتهاء",
      dataIndex: "expire_at",
      key: "expire",
      render: formatDate,
    },
    {
      title: "درجة الامتحان",
      dataIndex: "quiz_degree",
      key: "degree",
      render: (degree) => degree || "-",
    },
    {
      title: "تاريخ الامتحان",
      dataIndex: "quiz_submited_at",
      key: "submitted",
      render: formatDate,
    },
    {
      title: "درجة الواجب",
      dataIndex: "homework_degree",
      key: "degree",
      render: (degree) => degree || "-",
    },
    {
      title: "تاريخ الواجب",
      dataIndex: "homework_submited_at",
      key: "submitted",
      render: formatDate,
    },

    {
      title: "الكود المستخدم",
      dataIndex: "code_used",
      key: "code",
      render: (code) => code || "-",
    },
  ];

  return (
    <div dir="rtl">
      <div className="flex items-center justify-between mb-4">
        <Title level={3} className="dark:text-white">
          المحاضرات
        </Title>
        <input
          type="text"
          placeholder="بحث علي المحاضرات"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="signin-inputs signin-input my-7 pl-4 max-w-7xl !text-start placeholder:!text-secondary !border-secondary"
        />
      </div>
      <div className=" w-full  overflow-hidden rounded-xl border-2  border-secondary">
        <Table
          columns={columns}
          dataSource={filteredHistories}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 10 }}
          scroll={{ x: "max-content" }}
        />
      </div>
    </div>
  );
}
